import { render } from "./TurnstileWidget.vue?vue&type=template&id=5e21cc9d"
import script from "./TurnstileWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TurnstileWidget.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/TurnstileWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e21cc9d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e21cc9d', __exports__)) {
    api.reload('5e21cc9d', __exports__)
  }
  
  module.hot.accept("./TurnstileWidget.vue?vue&type=template&id=5e21cc9d", () => {
    api.rerender('5e21cc9d', render)
  })

}


export default __exports__